export enum ProviderTypeEnum {
    Internal = 1,
    External = 2,
    AllInternal = 3,
}
